// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"d39f6052","715":"7f03bf05","806":"0a8949ee"}[chunkId] + ".chunk.css";
};